import Phaser from 'phaser';
import { store } from '../stores/mainStore';
import {i18n} from '../i18n';

export class DicePopper{
	constructor(mng, diceHand) { 
		this.m = mng; 
		this.diceHand = diceHand;
		this.btnBkgScale = 0.7;
	}
	create() {
		this.homeY = 0.83* this.m.config.height
		const createBtn = name => this.m.scene.add.image(0.5* this.m.config.width, this.homeY, name)
			.setScale(this.btnBkgScale).setDepth(3)
		this.popperBtnBkg = createBtn('popper_button')
			.on('pointerdown', () => {
				//this.btnEnable(false)
				//this.m.playHaptic()
				this.m.playAudio('dice-popper');
				this.pressAnimation = this.m.scene.tweens.add({
					targets:[this.popperBtnBkg, this.popperBtnGrey, this.popTxt/* , this.popNumTxt */],
					y: '+='+10, duration: 25, 
					yoyo: true, hold: 100,
					onYoyo: () => {
						if(this.pressAnimation) {
							this.pressAnimation = null;
							this.onClick();
						}
					}
				})
			})
		this.popperBtnGrey = createBtn('popper_button_grey').setVisible(false)

		const style = {fill: '#ffffff', font: '900 50px ' + this.m.ui.dodFontFamily,
			shadow: {offsetX: 0, offsetY: 4, color: '#00000059', fill:true}
		};
		const x = this.popperBtnBkg.x, y = this.popperBtnBkg.y - 0.1*this.popperBtnBkg.height;
		this.popTxt = this.m.scene.add.text(x, y, i18n.t('skillz_pop_btn'), style)
			.setFontSize(80).setOrigin(0.5, 0.25).setDepth(3)
		//this.popNumTxt = this.m.scene.add.text(x, y, 0, style).setFontSize(150).setOrigin(0.5, 0.05).setDepth(3)

		this.diceImages = this.diceHand.dice.map(d => d.diceImage);
		//this.showLogoDice();

		this.hide();
	}

	show(buttonOnly = false){
		//if(store.activeMatch && store.activeMatch.currentHand && store.activeMatch.currentHand.rollsRemaining)
		//	this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		if(buttonOnly)		this.showBtn(false)
		else 				this.showDices(false)
	}
	hide() {
		if(this.btnTween)	this.btnTween.stop(0);	
		if(this.diceTween)	this.diceTween.stop(0);
		//this.btnEnable(false, false)
		this.hideBtn();
	}
	hideBtn() {
		this.popperBtnBkg.alpha = this.popperBtnGrey.alpha = this.popTxt.alpha /* = this.popNumTxt.alpha */ = 0;
	}
	updateButtonColor (inBonus) {
		this.popperBtnBkg.setTexture(inBonus ? 'popper_bonus' : 'popper_button')
	}

	startRound() {
		this.showLogoDice();
		//this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		this.showDices(!store.isInBonusGame);
	}
	onClick() {
		this.hideBtn();
		this.btnEnable(false);
		//this.popNumTxt.setText(store.activeMatch.currentHand.rollsRemaining)
		if(store.isInBonusGame)
			this.m.ui.bonusGame.dealDice();
		else 
			this.m.gameState = 'bet';
	}

	animation() {
		const scene = this.m.scene, dh = this.diceHand;
		const getCoords = () => {
			const centerPos = dh.getDiceHomePosition(4);
			return Array.from(new Array(9), (v, i) => {
				const pos = dh.getDiceHomePosition(i), isCenter = i === 4, max = 1.3;
				const ang = Phaser.Math.Angle.BetweenPoints(centerPos, pos);
				const dist = isCenter ? dh.diceActualWidth/3 : Phaser.Math.Distance.BetweenPoints(centerPos, pos);
				const addAng = ang + Phaser.Math.Angle.Random() * (isCenter ? 2 : 1/8);
				const coo = {
					x: centerPos.x + max*dist * Math.cos(addAng),
					y: centerPos.y + max*dist * Math.sin(addAng)
				}
				return coo;
			})
		}
		const roll3d = (_timeline, _targets, d, i) => {
			//d.diceImage.setTexture(store.custom.dice + '_dice3D_sheet', i * 9 + (++d.frameNum % 9))
			d.diceImage.setTexture('dice3D_sheet', i * 9 + (++d.frameNum % 9))
		}
		const backTo2d = (_timeline, _targets, d, i) => {
			this.showCardFace(d, i);
			d.diceImage.setScale(1);
		}

		//const t1 = 250, t2 = 125, t3 = 100, t4 = 150, t5 = 250;
		const t1 = 100, t2 = 100, t3 = 100, t4 = 100, t5 = 100;
		const enlarge = getCoords().map((coo, i) => {
			const d = dh.dice[i];
			return d.locked ? null : {
				targets: d.diceSprite, duration: t1, offset: 0,
				x: coo.x, y: coo.y, scale: 1.2,
				rotation: (Math.PI/4 + Phaser.Math.Angle.Random() /10) * (Math.random() < 0.5 ? 1 :  -1)
			}
		}).filter(Boolean)
		const drop = () => dh.dice.map((d, i) => {return d.locked ? null : {
			targets: d.diceSprite, duration: t2, offset: 0,
			x: dh.getDiceHomePosition(i).x, 
			y: dh.getDiceHomePosition(i).y, scale: 0.5,
			rotation: '*=' + (t1 + t2)/t1,
			onComplete: () => { d.frameNum = 0;}
		}}).filter(Boolean)
		const enlarge3d = getCoords().map((coo, i) => {
			const d = dh.dice[i];
			return d.locked ? null : {
				targets: d.diceSprite, duration: t3, offset: 0,
				x: coo.x, y: coo.y, scale: 2,
				onUpdate: roll3d, onUpdateParams: [d, i]
		}}).filter(Boolean)
		const rolling3d = dh.dice.map((d, i) => {
			return d.locked ? null :{
				targets: d.diceSprite, offset: 0,
				duration: 50, val: {from: 0, to: 1}, 
				onUpdate: roll3d, onUpdateParams: [d, i],
		}}).filter(Boolean)
		const stop3d = dh.dice.map((d, i) => {
			const time = Math.floor(t4 * Math.random())
			return d.locked ? null :{
				targets: d.diceSprite, offset: 0,
				duration: time, val: {from: 0, to: 1}, 
				onUpdate: roll3d, onUpdateParams: [d, i],
				onComplete: backTo2d, onCompleteParams: [d, i]
		}}).filter(Boolean)
		const shrink = dh.dice.map((d, i) => {return d.locked ? null : {
			targets: d.diceSprite, duration: t5, offset: 0,
			x: dh.getDiceHomePosition(i).x, 
			y: dh.getDiceHomePosition(i).y, 
			scale: 1, rotation: 0
		}}).filter(Boolean)
		
		this.diceHand.diceStatus = 'rolling';

		scene.tweens.timeline({tweens: enlarge,
			onStart: () => this.m.playAudio('diceRoll'),
			onComplete: () => { scene.tweens.timeline({tweens: drop,
				onComplete: () => { scene.tweens.timeline({tweens: enlarge3d,
					onComplete: () => scene.tweens.timeline({
						tweens: rolling3d,
						loop: -1, onLoop: checkRollReceived
					})
				})}
			})}
		})

		const checkRollReceived = (timeline) => {
			if(store.activeMatch?.currentHand?.rolled || store.isInBonusGame) {
				timeline.stop();
				scene.tweens.timeline({tweens: stop3d,
					onComplete: () => { scene.tweens.timeline({tweens: shrink,
						onComplete: onAnimComplete
					})}
				})
			}
		}
		const onAnimComplete = () => {
			console.log('4564 POP anim complete')
			this.m.playAudio('bumper')
			this.diceHand.diceStatus = 'resolved';
			if(store.isInBonusGame) {
				this.m.ui.bonusGame.rollResult()
				this.hide();
			} else {
				//this.m.allDiceResolved();
				this.m.gameState = 'endRoll';
			}
		}
	}

	showLogoDice() {
		this.diceImages.forEach((di, i) => di.setTexture('logo_dice_sheet', i))
		this.diceHand.diceStatus = 'logo';
	}
	showCardDice() {
		this.diceHand.dice.forEach((d, i) => this.showCardFace(d, i))
	}
	showCardFace = (dice, i) => {
		dice.frameNum = -1;
		dice.currentFace = !!(store.isInBonusGame && store.curBonusRound) 
			? store.curBonusRound.startDiceFaces[i] 
			: store.activeMatch.currentHand.diceFaces[i];
		//dice.diceImage.setTexture(store.custom.dice + '_dice2D_sheet', dice.currentFace);
		dice.diceImage.setTexture('dice2D_sheet', dice.currentFace);
	}

	btnEnable = (par, showGrey = true) => {
		if(par) {		// enable btn
			this.popperBtnBkg.setInteractive({useHandCursor: true}).setScale(this.btnBkgScale)
			this.pulseInterval = setInterval(() => {
				this.m.ui.makePulsate(this.popperBtnBkg, 200, 1.1, false)
			}, 3000)
		} else {		// disable btn
			clearInterval(this.pulseInterval)
			this.popperBtnBkg.disableInteractive().setScale(this.btnBkgScale);
		}
		if(showGrey)	this.popperBtnGrey.setVisible(!par)
	}

	showDices = animated => {
		const isLogoDice = !store.activeMatch || !store.activeMatch?.currentHand?.dice?.some(d => d.showing)
		/* if(isLogoDice)
			this.showLogoDice(); */
		this.diceHand.dice.forEach(d => {
			d.diceSprite.setX(d.homePosition.x).setY(d.homePosition.y).setScale(1)
			d.diceImage.setAlpha(animated ? 0.5 : 1)
		});
		if(animated)
			this.diceTween = this.m.scene.tweens.add({targets: this.diceImages,
				alpha: {from: 0, to: 1}, duration: 100, 
				//delay: (tar, key, v, i) => 50*i,
				onStart: () => {if(!isLogoDice)	this.m.playAudio('diceRoll')},
				onComplete: () => this.showBtn(animated)
			})
		else this.showBtn(animated)
	}
	showBtn = animated => {
		const onComplete = () => {
			if(this.m.gameState !== 'userPlay' && !store.isInBonusGame) 
				this.m.gameState = 'userPlay';
		}
		if(!animated) {
			this.popperBtnBkg.alpha = this.popperBtnGrey.alpha = this.popTxt.alpha = 1;
			onComplete();
		} else {
			this.btnTween = this.m.scene.tweens.add({duration: 200,
				targets: [this.popperBtnBkg, this.popperBtnGrey, this.popTxt],
				alpha: {from: 0, to: 1}, onComplete
			})			
		}
	}
}